import React from 'react';
import { cnTumbler } from '../Tumbler';
import './Tumbler-Label.css';
export var TumblerLabel = function (_a) {
    var disabled = _a.disabled, htmlFor = _a.htmlFor, id = _a.id, onClick = _a.onClick, children = _a.children;
    return (React.createElement("label", { "aria-hidden": "true", htmlFor: disabled ? undefined : htmlFor, id: id, onClick: onClick, className: cnTumbler('Label') }, children));
};
